import { render, staticRenderFns } from "./Teff.vue?vue&type=template&id=3692c5e2&scoped=true&"
import script from "./Teff.vue?vue&type=script&lang=js&"
export * from "./Teff.vue?vue&type=script&lang=js&"
import style0 from "./Teff.vue?vue&type=style&index=0&id=3692c5e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3692c5e2",
  null
  
)

export default component.exports